export default class Microsites {
  constructor() {
    this.init();
  }

  init() {
    this.handleMenu();
  }

  handleMenu() {
    const $btn = $('.js-btn-menu');

    $btn.click(function (e) {
      $(this).toggleClass('open');
      $('.global-header').toggleClass('open');
      $('.js-toggle-menu').toggleClass('open');
    });
  }
}
